export default "__VITE_ASSET__1f3cd531__"